import React from 'react';

/**
 * Benefits — four large-KPI benefit cards. Auto-numbered when inside `.numbered-sections`.
 */
export default function Benefits() {
  const benefits = [
    {
      kpi: '98 %',
      label: 'Mieteinzugsquote portfolioweit',
      body:
        'Und das seit mehr als 5 Jahren. Wir stehen dafür ein, dass Forderungen pünktlich und korrekt ausgeglichen werden. Auch Rückstände aus der Zeit vor unserer Übernahme treiben wir konsequent ein - falls nötig gerichtlich.',
    },
    {
      kpi: '<5 %',
      label: 'Leerstand in den ersten 12 Monaten',
      body:
        'Egal, was die Ursachen für die Leerstände sind: Wir beseitigen sie. Wir liefern die besten Mieter im Schnitt in unter 1,5 Monaten.',
    },
    {
      kpi: '1',
      label: 'verantwortlicher Ansprechpartner',
      body:
        'Keine Sachbearbeiter-Hotline, kein Pool-Modell. Pro Mandat ein Ansprechpartner. Kontinuität in allen Bereichen für Sie und Ihr Vermögen.',
    },
    {
      kpi: '24/7',
      label: 'Erreichbarkeit',
      body:
        'Unsere Experten sind für unsere Kunden 24/7 verfügbar. Für Mieter gibt es klare Notfallprozesse, um Schäden sofort einzudämmen.',
    },
  ];

  return (
    <section style={{ padding: '140px 0' }}>
      <div className="shell">
        <div className="section-label numbered reveal" style={{ marginBottom: 28 }}>
          <span>Klare Vorteile</span>
        </div>
        <h2 className="h-section reveal" style={{ marginBottom: 72, maxWidth: '22ch' }}>
          Was sich für Sie verändert.
        </h2>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 0,
            borderTop: '1px solid var(--cream-line)',
          }}
        >
          {benefits.map((b, i) => (
            <div
              key={i}
              className="reveal"
              style={{
                padding: '44px 40px 44px 0',
                paddingLeft: i % 2 === 0 ? 0 : 40,
                borderRight: i % 2 === 0 ? '1px solid var(--cream-line)' : 'none',
                borderBottom: '1px solid var(--cream-line)',
              }}
            >
              <div
                style={{
                  fontFamily: 'var(--serif)',
                  fontSize: 'clamp(40px, 4.4vw, 56px)',
                  lineHeight: 1,
                  color: 'var(--bordeaux)',
                  marginBottom: 8,
                  letterSpacing: '-0.01em',
                }}
              >
                {b.kpi}
              </div>
              <div className="eyebrow" style={{ marginBottom: 18 }}>
                {b.label}
              </div>
              <p className="body-prose" style={{ fontSize: 16 }}>
                {b.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
